import styles from './skeleton.module.scss';

export default function Skeleton() {
  return (
    <div className={styles.skeleton} />
  );
}
